import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Site from './components/Site';
import NotFound from './components/NotFound';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Site />} />

      {/* The site is one page now — keep the old routes pointing at its sections. */}
      <Route path="/about" element={<Navigate to="/#top" replace />} />
      <Route path="/projects" element={<Navigate to="/#work" replace />} />
      <Route path="/contact" element={<Navigate to="/#contact" replace />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
